import React from 'react';

import classes from './ToolBar.module.css';
import Logo from '../../Logo/Logo';
import NavigationItems from '../NavigationItems/NavigationItems';
import DrawerToggle from '../SideDrawer/DrawerToggle/DrawerToggle';

const ToolBar = (props) => {
    return (
        <header className={classes.ToolBar} >
            <DrawerToggle clicked={props.drawerToggleClicked}/>
            <div className={classes.Logo}>
                <Logo />
            </div>
            <nav className={classes.DeskTopOnly}>
                <NavigationItems
                    isLoggedIn={props.isLoggedIn}
                />
            </nav>
        </header>
    );
};

export default ToolBar;
